export const FILE_SIZE_EXCEEDS_MAXIMUM = "size_exceeds_maximum";
export const FILE_TYPE_UNACCEPTABLE = "unacceptable_type";
export const FILES_COUNT_EXCEEDS_MAXIMUM = "count_exceeds_maximum";